import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'
import EmailIcon from '@mui/icons-material/Email'

const Email = () => {
  return (
    <Box
      sx={{
        p: 2,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <EmailIcon sx={{ fontSize: 45, color: 'primary.main', mb: 4 }} />
      <Typography
        variant="h5"
        fontWeight="bold"
        color="primary.main"
        sx={{ mb: 3 }}
      >
        Email
      </Typography>

      <Box
        sx={{
          bgcolor: 'secondary.main',
          height: 2,
          width: { xs: '50%', sm: '40%' },
          my: 1,
        }}
      />
      {/* <Typography
        variant='subtitle1'
        color='gray'
        align='center'
        sx={{ mb: 3 }}
      >
        A wonderful serenity has taken possession of my entire soul, like these
        sweet mornings.
      </Typography> */}
      <Button
        sx={{
          mb: 3,

          textTransform: 'none',
          fontSize: 15,
        }}
        component="a"
        href="mailto:info@rgbjute.com"
      >
        info@rgbjute.com
      </Button>
    </Box>
  )
}

export default Email
